export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-biks-line/60 bg-biks-bg"
        >
            <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-8 text-xs text-biks-text3 sm:flex-row sm:items-center sm:justify-between lg:px-10">
                <span>
                    BoM · Break or Make. Rule-based diagnostic.
                    Not investment advice.
                </span>
                <span className="font-mono-data uppercase tracking-[0.22em]">
                    v8 / no AI
                </span>
            </div>
        </footer>
    );
};

export default Footer;
